export const TypeComp = ({title,description,tabList}) => {
  return (
    <div className="w-[120px] lg:w-[250px] rounded overflow-hidden shadow-lg bg-neutral p-4 text-white">
      <div className="font-bold text-xs lg:text-xl mb-2">{title}</div>
      <p className="text-white text-xs lg:text-base mb-4">
      {description}
      </p>
      <ul className="list-disc list-inside text-xs lg:text-md">
      {tabList.map((e,index)=><li key={index}>{e}</li>)}
      </ul>
    </div>
  );
};
